<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp-fm"> </p>
<p class="Dedication-ded"><span epub:type="pagebreak" id="pg_5" title="5"><span class="ePub-I">To Melinda Snodgrass, for saving my life, for helping me improve my craft, and for being my friend for longer than would be kind to either of us to mention.</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f7926192